import { type BroadcastState, broadcastStateFromJson } from "./broadcast.js";

export type SessionHealth = "active" | "gone" | "unknown" | "skipped";

export interface BroadcastOperatorStatus extends BroadcastState {
  sessionHealth: SessionHealth;
  sessionHealthDetail?: string;
  uptimeMs?: number;
}

function parseSessionHealth(value: unknown): SessionHealth {
  if (value === "active" || value === "gone" || value === "unknown" || value === "skipped") {
    return value;
  }
  return "unknown";
}

export function broadcastOperatorStatusFromJson(
  json: Record<string, unknown>,
): BroadcastOperatorStatus {
  const base = broadcastStateFromJson(json);
  return {
    ...base,
    sessionHealth: parseSessionHealth(json.sessionHealth),
    sessionHealthDetail:
      typeof json.sessionHealthDetail === "string" ? json.sessionHealthDetail : undefined,
    uptimeMs: typeof json.uptimeMs === "number" ? json.uptimeMs : undefined,
  };
}
